export default {
  getHead: () => {
    return [{ name: "현장명" }, { name: "회차" }, { name: "점검일" }, { name: "재해형태" },  { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 현장명
      case 1:
        return func.getContent(value).inputB_7; // 회차
      case 2:
        return func.getContent(value).inputB_1; // 점검일
      case 3:
        return func.getContent(value).inputB_3.join(", "); // 재해형태
      case 4:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 5:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "content$body.inputB_1";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return {
      disasterType: nav.value.disasterType,
      searchType: nav.value.searchType,
      searchKeyword: nav.value.searchKeyword,
    };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push("content$body.inputB_3*%[:default_disaster]%");

    switch (nav.value.searchType) {
    case "현장명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "회차":
      returnData.push("content$body.inputB_7*%[:default_skw]%");
      break;
    case "소속명":
      returnData.push("content$body.stdInfo.department*%[:default_skw]%");
      break;
    case "부서명":
      returnData.push("content$body.stdInfo.section*%[:default_skw]%");
      break;
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
